import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Select } from 'antd';
import { send_email_options_no_price } from '../statics';

const mapStateToProps = (state) => ({
    root_id: state.Leads.Lead_profile.Lead_general.root_id,
    current_status: state.Leads.Lead_profile.Lead_general.current_status,
    ref_lead_source: state.Leads.Lead_profile.Lead_marketing.ref_lead_source,
    is_trade: state.Leads.Lead_profile.Lead_general.trade ? state.Leads.Lead_profile.Lead_general.trade.is_trade : false,
}); const { Option } = Select; const
    FormItem = Form.Item;

export default connect(mapStateToProps, null)(class SendEmailModal extends PureComponent {
  state = {
      value: '',
      key: 0,
  };

  handleChange = (value, key) => this.setState({ value, key: key.key });

  sendEmail = () => {
      this.props.dispatch({ type: 'SEND_EMAIL_REQUEST', template_id: +this.state.key, lead_id: this.props.root_id });
      this.props.closeModal();
  };
  /* divisions =
  [
          {abbr: "WWYM", name: "WeWantYourMotorbike.com", _id: "5be93e5f683059f77dbcef48"},
          {_id: "5be93e5f683059f77dbcef49", abbr: "MBT", name: "MotorbikeTrader.com"},
          {_id: "5be93e5f683059f77dbcef4a", abbr: "WWAB", name: "WeWantBikes.com"},
          {_id: "5be93e5f683059f77dbcef4b", abbr: "SBF", name: "SuperBikeFactory.co.uk"},
          {_id: "5be93e5f683059f77dbcef4c", abbr: "LoM", name: "Lead-o-matic"},
          {_id: "5caf0ab9c2520a5844ef6a89", abbr: "SBF - Part Ex", name: "SBF - Part Ex"},
  ]; */

  chooseTemplateID = ({ _id }) => {
      switch (_id) {
      // WeWantYourMotorbike.com
      // Lead-o-matic
      case '5be93e5f683059f77dbcef48':
          return 136;

          // MotorbikeTrader.com
      case '5be93e5f683059f77dbcef49':
          return 64;
          // SuperBikeFactory.co.uk
      case '5be93e5f683059f77dbcef4c':
      case '5d6cd33b6f5dd301d539d68c':
      case '5be93e5f683059f77dbcef4b':
          return 97;
          // SBF - Part Ex
      case '5caf0ab9c2520a5844ef6a89':
          return 4;
      default:
          return null;
      }
  };

  render() {
      const send_email_options = [
          { value: 'Valuation Offer', template_id: 5 },
          { value: 'Amended Offer', template_id: 3 },
          { value: 'Tried To Call', template_id: 2 },
          { value: 'Wrong Number Supplied', template_id: 1 },
      ];

      if (this.props.ref_lead_source._id === '5be93e5f683059f77dbcef4c' || this.props.ref_lead_source._id === '5caf0ab9c2520a5844ef6a89') {
          send_email_options.pop();
      }
      return (
          <Form>

              <FormItem label="Please choose which email from the list below to send to this customer">
                  <Select
                      showSearch
                      placeholder="Email"
                      notFoundContent="Email not Found"
                      value={this.state.value}
                      onChange={this.handleChange}
                  >
                      <Option value="" style={{ color: 'lightgray' }} disabled>Select Option</Option>
                      {this.props.current_status.name === 'Pending'
                          ? send_email_options_no_price.map((value) => <Option value={value.value} key={value.template_id}>{value.value}</Option>)
                          : send_email_options.map((value) => <Option value={value.value} key={value.template_id}>{value.value}</Option>)}
                  </Select>
              </FormItem>
              <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                  <Button onClick={this.props.closeModal}>Cancel</Button>
                  <Button style={{ marginLeft: 10 }} disabled={!this.state.value} type="primary" onClick={this.sendEmail}>Send</Button>
              </div>
          </Form>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/components/Modals/SendEmailModal.js